@if (dashboards.length > 0) {
  <div class="dashboard__container">
    <router-outlet></router-outlet>
  </div>
}
@if (dashboards.length === 0 && !isLoadingDashboards) {
  <div class="dashboard__error__container">
    <div class="d-flex flex-column justify-content-center align-items-center">
      <div class="error-icon-container">
        <img src="../../../../../assets/images/icons/space_dashboard.svg" alt="" />
      </div>
      <p class="error-title">No dashboards available</p>
      <p class="error-message">Dashboards become available once the organization subscribes to</p>
      <p class="error-message">UDT NOC, SOC or Help Desk services.</p>
    </div>
  </div>
}
